import { render } from "./RedesSociais.vue?vue&type=template&id=17837bc1&scoped=true"
import script from "./RedesSociais.vue?vue&type=script&lang=js"
export * from "./RedesSociais.vue?vue&type=script&lang=js"

import "./RedesSociais.vue?vue&type=style&index=0&id=17837bc1&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17837bc1"]])

export default __exports__